import { routes as patientReportsRoutes } from "./patient-reports/routes";
import { routes as accountsFinanceRoutes } from "./accounts-finance/routes";
export const routes = [

    ...patientReportsRoutes(),
    ...accountsFinanceRoutes(),
];